import React from "react"


export const SearchIconSvg = () => {
    return(
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3636 3.74219C8.90722 3.74219 7.48354 4.17405 6.2726 4.98318C5.06167 5.7923 4.11786 6.94234 3.56052 8.28786C3.00319 9.63338 2.85737 11.1139 3.14149 12.5423C3.42562 13.9707 4.12693 15.2828 5.15675 16.3126C6.18657 17.3424 7.49863 18.0438 8.92703 18.3279C10.3554 18.612 11.836 18.4662 13.1815 17.9089C14.527 17.3515 15.6771 16.4077 16.4862 15.1968C17.2953 13.9858 17.7272 12.5622 17.7272 11.1058C17.7271 9.15287 16.9512 7.27999 15.5703 5.89907C14.1894 4.51816 12.3165 3.74231 10.3636 3.74219Z" stroke="#04090D" stroke-opacity="0.9" stroke-width="2" stroke-miterlimit="10"/>
<path d="M15.8594 16.6016L21.002 21.7442" stroke="#04090D" stroke-opacity="0.9" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
</svg>)
}
